import { PrimaryFocus } from '../constant'

export const getNearByCarouselTitle = (
  primaryFocus: PrimaryFocus | undefined
): string => {
  switch (primaryFocus) {
    case PrimaryFocus.MENTAL_HEALTH:
      return 'Nearby Mental Health Centers to Consider'
    case PrimaryFocus.SUBSTANCE_USE:
      return 'Nearby Substance Use Treatment to Consider'
    case PrimaryFocus.EATING_DISORDERS:
      return 'Nearby Eating Disorder Treatment to Consider'
    default:
      return 'Nearby Centers to Consider'
  }
}
